import { Link, NavLink } from "react-router-dom";
import { Yacht } from "./model";
import { ColumnDef } from "@tanstack/react-table";
import { EllipsisVerticalIcon, ExternalLinkIcon } from "lucide-react";
import { Button } from "@/src/components/ui/button";
import { Dialog, DialogTrigger } from "../../components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import YachtLabel from "@/src/components/ui/yacht-label";

export const yachtsColumns: ColumnDef<Yacht>[] = [
  {
    header: "Yacht name",
    cell: ({ row }) => (
      <div className="flex items-center gap-x-5 w-[400px]">
        <img
          className="min-w-[130px] h-[80px] rounded-[5px]"
          width={130}
          height={80}
          src={row.original.media[0]}
          alt={row.original.name}
        />
        <div>
          <span className="text-base">“{row.original.name}”</span>
          <YachtLabel apiDateUpdated={row.original.apiDateUpdated} apiStatus={row.original.apiStatus} />
        </div>
      </div>
    ),
  },
  {
    header: "Model",
    accessorFn: (r) => r.model,
  },
  {
    header: "Brand",
    cell: ({ row }) => {
      return (
        <span className="text-sm">
          {[row.original.visibleInAnchor && "Anchor", row.original.visibleInHelm && "Helm"].filter(Boolean).join(", ")}
        </span>
      );
    },
  },
  {
    header: "Year",
    accessorFn: (r) => r.year,
  },
  {
    header: "Type",
    accessorFn: (r) => r.boatType,
  },
  {
    header: "Location",
    accessorKey: "location",
  },
  {
    header: "Charter type",
    accessorKey: "type",
  },
  {
    header: "No. of guests",
    accessorKey: "maxPeople",
  },
  {
    header: "No. of cabins/berths",
    accessorKey: "cabins",
  },
  {
    header: "No. of bathrooms/heads",
    accessorKey: "bathrooms",
  },
  {
    header: "Supplier",
    accessorKey: "operator",
  },
  {
    header: "Databases",
    accessorKey: "provider",
  },
  {
    header: "Starting price/week",
    cell: ({ row }) => {
      return <span className="text-md mx-1.5">€{"N/A"}</span>;
    },
  },
  {
    header: "Extra services",
    cell: (props) => {
      return (
        <Button variant="secondary" asChild>
          <Link to={`/yachts/${props.row.original.id}?step=Amenities`}>Extras</Link>
        </Button>
      );
    },
  },
  // {
  //   header: "Availability",
  //   cell: (props) => {
  //     return (
  //       <Button variant="secondary" asChild>
  //         <Link to="/yacht-details/id">
  //           Availability
  //           <ExternalLinkIcon className="ml-2" size={16} />
  //         </Link>
  //       </Button>
  //     );
  //   },
  // },
  {
    header: "Yacht page",
    cell: (props) => {
      const slug = props.row.original.slug;
      const frontUrl =
        process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
          ? `https://helm-web-test.adchitects.co/yacht/`
          : `https://helm.yt/yacht/`;
      return (
        <Button onClick={(e) => e.stopPropagation()} variant="secondary" asChild>
          <Link target="_blank" to={frontUrl + slug}>
            Yacht page
            <ExternalLinkIcon className="ml-2" size={16} />
          </Link>
        </Button>
      );
    },
  },
  // {
  //   header: "Booking sheet",
  //   cell: (props) => {
  //     return (
  //       <Button variant="secondary" asChild>
  //         <Link to="/yacht-details/id">
  //           Booking sheet
  //           <ExternalLinkIcon className="ml-2" size={16} />
  //         </Link>
  //       </Button>
  //     );
  //   },
  // },
  // {
  //   header: "Our bookings",
  //   cell: (props) => {
  //     return (
  //       <Button variant="secondary" asChild>
  //         <Link to="/yacht-details/id">
  //           Our bookings
  //           <ExternalLinkIcon className="ml-2" size={16} />
  //         </Link>
  //       </Button>
  //     );
  //   },
  // },
  {
    id: "actions",
    size: 32,
    cell({ row }) {
      return (
        <Dialog>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="p-1 h-fit">
                <EllipsisVerticalIcon />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DialogTrigger asChild>
                <DropdownMenuItem>See details</DropdownMenuItem>
              </DialogTrigger>
              <DropdownMenuItem>
                <NavLink to={`/yachts/${row.original.id}`}>Overwrite the details</NavLink>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </Dialog>
      );
    },
  },
];
